import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fec4be8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "step-two"
};
const _hoisted_2 = {
  class: "qrcode-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "scan-tips"
}, " *请使用手机「微信」扫描二维码，并提前在手机「设置」中将屏幕自动锁定时间改为“永不”或最大时长 ", -1));
const _hoisted_4 = {
  class: "qrcode-section"
};
const _hoisted_5 = {
  class: "scan-area"
};
const _hoisted_6 = {
  class: "qrcode-area"
};
const _hoisted_7 = {
  class: "qrcode-box"
};
const _hoisted_8 = {
  class: "qrcode"
};
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"corner-area\" data-v-fec4be8e><span class=\"lt\" data-v-fec4be8e></span><span class=\"rt\" data-v-fec4be8e></span><span class=\"lb\" data-v-fec4be8e></span><span class=\"rb\" data-v-fec4be8e></span></div>", 1);
const _hoisted_10 = {
  class: "intro-area"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips-title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "注意事项"), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
})], -1));
const _hoisted_12 = {
  class: "photo-demo"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "photo-tips"
}, "将手机放置45度斜角位置，覆盖半身", -1));
const _hoisted_15 = {
  class: "action-step"
};
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 已在手机上确认 ");
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
import { onMounted, onUnmounted, watch, reactive, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import qrcode from 'qrcode';
import GuidePage from '@/assets/image/envCheck/device-guide.png';
import { DaoService } from '@/services/dao.service';
import { logger } from '@/utils';
export default {
  setup(__props) {
    const daoService = useService(DaoService);
    const checkerService = useService(EnvCheckerService);
    const canvasRef = ref();
    const qrcodeCreating = ref(false);
    const goNextStep = async () => {
      await checkerService.updateMobileCheckResult();
      checkerService.goStep(2);
    };
    const refreshQrcodeFn = (time = 0) => {
      qrcodeCreating.value = true;
      daoService.getTrtcRoomInfo({
        userExamId: checkerService.userExamId,
        contestInfoId: checkerService.contestInfoId,
        platform: 'mobile'
      }).then(res => {
        var _checkerService$userS;
        const {
          roomId,
          sdkAppId,
          userSig,
          examStartTime
        } = res;
        const pageUrl = `${location.protocol}//` + location.host + '/mobile/#/room?' + new URLSearchParams({
          roomId,
          sdkAppId: sdkAppId.toString(),
          userSig,
          examStartTime: time ? Date.now() + time * 60 * 1000 : examStartTime,
          userId: (_checkerService$userS = checkerService.userService) === null || _checkerService$userS === void 0 || (_checkerService$userS = _checkerService$userS.user) === null || _checkerService$userS === void 0 ? void 0 : _checkerService$userS.userId
        }).toString();
        logger.info(pageUrl);
        qrcode.toCanvas(canvasRef.value, pageUrl, {
          errorCorrectionLevel: 'M',
          margin: 0,
          scale: 10,
          width: 280
        }).finally(() => {
          qrcodeCreating.value = false;
        });
      });
    };
    onMounted(() => {
      refreshQrcodeFn();
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_spin, {
        spinning: qrcodeCreating.value,
        wrapperClassName: "check-loading"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("canvas", {
          ref: (_value, _refs) => {
            _refs['canvasRef'] = _value;
            canvasRef.value = _value;
          }
        }, null, 512)])]),
        _: 1
      }, 8, ["spinning"])]), _hoisted_9])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
        src: _unref(GuidePage),
        alt: ""
      }, null, 8, _hoisted_13)]), _hoisted_14])])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
        type: "primary",
        class: "confirm-btn",
        onClick: goNextStep
      }, {
        default: _withCtx(() => [_hoisted_16]),
        _: 1
      })])]);
    };
  }
};